import { render, staticRenderFns } from "./UserEcards.vue?vue&type=template&id=1d1f1340&scoped=true"
import script from "./UserEcards.vue?vue&type=script&lang=js"
export * from "./UserEcards.vue?vue&type=script&lang=js"
import style0 from "./UserEcards.vue?vue&type=style&index=0&id=1d1f1340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f1340",
  null
  
)

export default component.exports